import { useState, useEffect, FC } from "react";
import { GenericStorylineElementsList } from "../GeneralComponents/generic-storyline-list";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";

import { StoryElementArchiveDisplay } from "./archive-display";
import { Button, CircularProgress, Paper } from "@mui/material";

export function AutomaticArchiveManagement(){

    let [storyElements, setStoryElements] = useState([] as any[]);
    
    let [archivingRunning, setArchivingRunning] = useState(false);
    let [currentElement, setCurrentElement] = useState("Not started");

    function handleStartedClicked(){
        setArchivingRunning(true);
    }

    function archiveNext(){
        if(!archivingRunning){
            return;
        }
        if(storyElements.length == 0){
            setArchivingRunning(false);
            setCurrentElement("Archiving completed");
            return;
        }
        let element = storyElements[0];
        console.log(element.title);
        setCurrentElement(element.title);
        StorylineServerProxy.archiveStoryElement(element).then(() => {
            updateList();
        });
    }

    function updateList(){
        StorylineServerProxy.getUnarchivedStoryElements().then(elements => { 
            setStoryElements(elements);
        });
    }

    useEffect(() => {
        updateList();
    }, []);

    useEffect(archiveNext, [archivingRunning, storyElements]);

    return (
        <>
            <Paper elevation={4} sx={{ padding: 2}} >
                Automatic archiving&nbsp;
                { archivingRunning?<CircularProgress />:<Button onClick={handleStartedClicked}>Start</Button> }
                <br/>
                Currently archiving: { currentElement }
            </Paper>
            <GenericStorylineElementsList storyElements={storyElements} Component={StoryElementArchiveDisplay} updateListFromServer={updateList} /> 
        </>
    )
}